import React, { Component } from 'react';
import { CardBody, Card, Label, Col, Button, Row, Input } from 'reactstrap'
import { connect } from 'react-redux';
import { Preloading } from '../../components/UI/Preloader/action';
import fileSaver from 'file-saver';
import moment from 'moment';
import {
    submitKycPricingRequest,
    downloadKycPricingRequestTemplate
} from './action';
import {
    displayErrorMessage, displaySuccessMessage,
} from '../../Corporate/my-portfolio/monitoring/charts/monitoring-util'
import Modal from '../../components/UI/Modal/Modal';
import { toast } from 'react-toastify';

class KycUsagePricing extends Component {

    state = {
        kycUsagePricingRequestExcel: '',
        noExcelUploadWarning: '',
        resizeZIndex: false,
        showFailureModal: false,
        failureMessageHeading: '',
        failureMessageBody: ''
    };

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {
        if (this.props.kycUsageStatsFile !== prevProps.kycUsageStatsFile) {
            this.props.preloading(false);
            if (this.props.kycUsageStatsFile.status === "SUCCESS") {
                let statusCode = this.props.kycUsageStatsFile.data['status'];
                if (statusCode === 200) {
                    const data = this.props.kycUsageStatsFile.data.data;
                    let blob = new Blob([data], { type: 'application/octet-stream' });
                    fileSaver.saveAs(blob, `${"Kyc_Usage_Stats"}_${moment().format("DD_MMM_YYYY")}.xlsx`)
                } else if (statusCode === 204) {
                    displayErrorMessage("No data available!!")
                }
            } else if (this.props.kycUsageStatsFile.status === "FAILURE") {
                displayErrorMessage("Plesae try again later!!")
            }
        }

        
        if (this.props.downloadKycPricingRequestTemplateSuccess !== prevProps.downloadKycPricingRequestTemplateSuccess) {
            this.props.preloading(false)
            var blob = new Blob([this.props.downloadKycPricingRequestTemplateSuccess], { type: 'application/octet-stream' });
            fileSaver.saveAs(blob, `Pricing_request_template.xlsx`);
        }
        if (this.props.downloadKycPricingRequestTemplateFailure !== prevProps.downloadKycPricingRequestTemplateFailure) {
            this.props.preloading(false)
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Some error occured<br/>&nbsp;Please try again!
                </div>
            );
        }

        if (this.props.submitKycPricingRequestSuccess !== prevProps.submitKycPricingRequestSuccess) {
            this.props.preloading(false)

            if(this.props.submitKycPricingRequestSuccess.validationFailureReason) { //on validation failure
                let errorMessage = ''
                if(this.props.submitKycPricingRequestSuccess.errorCellsOfColumn.length > 0 ) { 
                    this.props.submitKycPricingRequestSuccess.errorCellsOfColumn.forEach(errorCell => {
                        let totalRows = errorCell.rows.length
                        if(totalRows > 0) {
                            let tempErrorMessage = `${errorCell.column} rows: `
                            tempErrorMessage += errorCell.rows[0]       //adding first element
                            let maxElemInALine = 10                  //excluding the first element

                            //starting from second element because first is already added in string
                            //formatting element line by line
                            for(let i = 1; i< totalRows; i+=maxElemInALine) {    //loop for each line
                                let elemUpperLimit = totalRows - i;             //calculating upper limit so element index cannot get outside
                                let noOfElemForLine = elemUpperLimit < maxElemInALine ? elemUpperLimit : maxElemInALine;        //calculating number of row elements for the current line
                                
                                for(let j=0; j < noOfElemForLine; j++)              // loop for formatting each element inside line
                                    tempErrorMessage += `, ${errorCell.rows[(i+j)]}`;
                                
                                tempErrorMessage += `\n`            //changing line after filling row elements
                            }
                            tempErrorMessage += `\n`
                            errorMessage += tempErrorMessage;
                        }
                    });
                }
                this.setState({
                    showFailureModal: true,
                    failureMessageHeading: this.props.submitKycPricingRequestSuccess.validationFailureReason,
                    failureMessageBody: errorMessage
                })
            }

            else{                               //on validation success
                this.setState({
                    noExcelUploadWarning: '',
                    kycUsagePricingRequestExcel: ''
                })
            
                toast.success(
                    <div>
                        <i className="fa fa-check-circle fa-lg"></i>&nbsp;Submitted Succesfully!
                    </div>
                );
            }
        }


        if (this.props.submitKycPricingRequestFailure !== prevProps.submitKycPricingRequestFailure) {
            this.props.preloading(false)
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Something went wrong!<br/>&nbsp;Please try again!
                </div>
            );
            
        }
    }
    
    handleTemplateDownload = () => {
        this.props.preloading(true)
        this.props.downloadKycPricingRequestTemplate({caseType: this.state.caseType})
    }

    uploadExcel = (event) => {
        this.setState({
            kycUsagePricingRequestExcel: event.target.files[0]
        })    
        
        event.preventDefault();
        event.target.value = null;
    }

    handleSubmit = () => {
        if(!this.state.kycUsagePricingRequestExcel) {
            this.setState({ noExcelUploadWarning: '*Please upload the filled request template!'})
        }
        else{
        this.props.submitKycPricingRequest({file: this.state.kycUsagePricingRequestExcel});
        this.props.preloading(true);
        }
    }

    handleCloseModal = () => {
        this.setState({
            showFailureModal:false
        })
    }

    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0 text-center">KYC Pricing</h4>
                </div>
                <Card>
                    <CardBody >
                        <Label>Pricing Report Form</Label>
                        <Row>
                            <Col sm='22'>
                                
                                <Button color="primary" onClick={this.handleTemplateDownload} className="btn color-excel-download ">
                                                            <i className="fa fa-file-excel-o fa-lg"></i>&nbsp;&nbsp;Request Template
                                </Button> 
                                <Row color="primary" className="btn btn-primary ml-0 position-relative excel-upload-btn browse-files ml-3" title="Upload Request Template">
                                    <input onChange={this.uploadExcel} type="file" name="file" id="file" className="upload-file" title="Upload Request Template" />
                                    <i className="fa fa-paperclip color-888 rotate-90deg p-1 fa-lg" /> Browse File(s)
                                    
                                </Row>
                                <Button className='ml-5' color='primary' onClick={this.handleSubmit}>Submit</Button>
                                <Row className={(this.state.kycUsagePricingRequestExcel) ? "text-muted ml-1 transaction-file-name-text" : "text-danger ml-1 noUploadWarning-text" }>{(this.state.kycUsagePricingRequestExcel) ? this.state.kycUsagePricingRequestExcel.name : this.state.noExcelUploadWarning}</Row>
                            </Col>
                            
                        </Row>
                    </CardBody>
                </Card>
                <Modal show={this.state.showFailureModal} className={this.state.resizeZIndex ? 'z-index-zero Large-Modal modal-content' : 'Large-Modal modal-content'} modalClosed={this.closeIt} >
                        <div className="modal-header row pt-0">
                        <h5 className="text-danger"><i className="fa fa-exclamation-triangle">&nbsp;</i>Failure</h5>
                            <button type="button" onClick={this.handleCloseModal} className="close outline-none" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>  
                        </div>
                        <div className="modal-body">
                            <h5>{this.state.failureMessageHeading}</h5><br/>
                            <pre className='validation-error-text'>{this.state.failureMessageBody}</pre>
                            <Button color="info" onClick={this.handleCloseModal}>OK</Button>
                        </div>
                </Modal>
            </Col>
        )
    }
}

const mapStateToProps = (state) => ({
    downloadKycPricingRequestTemplateSuccess: state.kycUsageReducer.downloadKycPricingRequestTemplateSuccess,
    downloadKycPricingRequestTemplateFailure: state.kycUsageReducer.downloadKycPricingRequestTemplateFailure,
    submitKycPricingRequestSuccess: state.kycUsageReducer.submitKycPricingRequestSuccess,
    submitKycPricingRequestFailure: state.kycUsageReducer.submitKycPricingRequestFailure,
})

const mapDispatchToProps = (dispatch) => ({
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    downloadKycPricingRequestTemplate: (data) => {dispatch(downloadKycPricingRequestTemplate(data))},
    submitKycPricingRequest: (data) => {dispatch(submitKycPricingRequest(data))}
});


export default connect(mapStateToProps, mapDispatchToProps)(KycUsagePricing);